import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar"; // Componente Sidebar ya existente
import Navbar from "../components/Navbar"; // Componente Navbar ya existente
import { getUserProfile } from "../slices/userSlice"; // Acción para obtener el perfil
import routes from "../routes"; // Importamos las rutas
import Notifications from "../pages/users/admin/notifications/notifications";
import Loading from "../components/Loading";
import WeeklySchedule from "../pages/users/admin/calendar/calendarApo";


export default function AdminDashboard() {
  const dispatch = useDispatch();
  

  const location = useLocation();
  const navigate = useNavigate()

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // Estado del sidebar desde Redux
  const { expanded } = useSelector((state) => state.sidebar);
  const { isDarkMode } = useSelector((state) => state.darkMode);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  // Estado del usuario
  const { userInfo, loading, error } = useSelector((state) => state.user);

  useEffect(() => {
    setIsSearchOpen(false);
  }, [location.pathname]);

  // Inicializamos el sidebar al montar el componente
  useEffect(() => {
    if (!userInfo || !userInfo.email) {
     
      dispatch(getUserProfile());
    }
  }, [dispatch, userInfo]);

  if (loading) {
    return <Loading/>
  }

  if (error) {
    navigate("/login")
  }

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar */}
      <Sidebar userInfo={userInfo} routes={routes} />

      {/* Main Content */}
      <div
        className={`flex-1 h-full sm:ml-20 ml-0 ${
          expanded ? "sm:ml-64 " : "ml-0"
        } transition-all `}
      >
        <Navbar
          isSearchOpen={isSearchOpen}
          setIsSearchOpen={setIsSearchOpen}
          routes={routes}
        />

        {/* Main content of the page */}
        <main className=" h-full">
          <Routes>
            {routes[0].pages.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
            {routes[0].pages[0].subpages.map((subpage) => (
              <Route
                key={subpage.path}
                path={subpage.path}
                element={subpage.element}
              />
            ))}
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/calendly" element={<WeeklySchedule/>} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
